import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CoachSettingsGeneralCertificatesController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-certificates/coach-settings-general-certificates.controller';

@Component({
	selector: 'spr-coach-settings-general-certificates-header',
	templateUrl: './coach-settings-general-certificates-header.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'md:block hidden',
	},
})
export class CoachSettingsGeneralCertificatesHeaderComponent {
	constructor(public controller: CoachSettingsGeneralCertificatesController) {}
}
